(function() {
    'use strict';
    angular
        .module('valueconnectApp')
        .factory('PriorityAppraiser', PriorityAppraiser);

    PriorityAppraiser.$inject = ['$resource'];

    function PriorityAppraiser ($resource) {
        var resourceUrl = 'api/regions/:regionId/priority-appraisers/:category';

        return $resource(resourceUrl, {}, {
            // Current priority appraisers for a region + category
            'query': { method: 'GET', isArray: true },
            // Appraisers eligible to be added (service the region + either capability flag for Desktop AVV & Second Opinion)
            'candidates': {
                method: 'GET',
                isArray: true,
                url: 'api/regions/:regionId/priority-appraisers/:category/candidates'
            },
            // Replace the full set; body is an array of appraiserUserIds
            'update': { method: 'PUT', isArray: true }
        });
    }
})();
